module.exports = __webpack_public_path__ + "static/PPNeueMontreal-Regular-ad87130367bc666dba72e069022921a0.eot";